export default points => {
  if ([NaN, null, undefined].includes(parseFloat(points)))
    return 0
  if (points > 999)
    return 999
  if (points < 0)
    return -(points)
  return points
}